// extracted by mini-css-extract-plugin
export default {"clickable":"UserSkillTable_clickable__7rcIZ"};